import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  setStart,
  setEnd,
  addItemArray,
  clearItems
} from '../redux/dates'
import * as CalendarItemTypes from 'const/CalendarItemTypes'

export default function * fetchDates (action) {
  const { start, end } = action.payload
  
  const state = yield select()
  const vBoardId = state['view-myboard'].view.id
  
  yield put([
    setStart(start),
    setEnd(end),
    setLoadStatus({
      isLoading: true,
      isLoaded: false
    })
  ])

  const { Events } = yield call(apiGetData, 'VBoardDatesByRange', {
    vBoardId,
    from: start,
    to: end
  })

  yield put([
    clearItems(),
    addItemArray(Events.filter(Item => Item.Type === CalendarItemTypes.CUSTOM_DATE).map(Item => ({
      id: Item.Id,
      cardId: Item.CardId,
      type: CalendarItemTypes.CUSTOM_DATE,
      name: Item.Name,
      timestamp: Item.Timestamp
    }))),
    setLoadStatus({
      isLoading: false,
      isLoaded: true
    })
  ])
}
